import { FormatsEnseignement } from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierFormatsEnseignementsCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private oldFormatsEnseignements: FormatsEnseignement,
        private newFormatsEnseignements: FormatsEnseignement
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierFormatsEnseignementObjetMaquette(this.id, this.version, this.newFormatsEnseignements)
            .pipe(tap(response => this.events.objetMaquetteModifie$.next(response)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierFormatsEnseignementObjetMaquette(this.id, this.version, this.oldFormatsEnseignements)
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }
}
